"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var Switch = /** @class */ (function (_super) {
    __extends(Switch, _super);
    function Switch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function () {
            _this.fire('change', _this._ele.checked);
        };
        return _this;
    }
    Switch.prototype.render = function (props) {
        var _this = this;
        if (props.checked) {
            return (omi_1.h("label", __assign({ for: "x_" + this.elementId }, omi_1.extractClass(props, 'o-switch-cp')),
                omi_1.h("input", { id: "x_" + this.elementId, ref: function (e) {
                        _this._ele = e;
                    }, class: "o-switch-cp__input", type: "checkbox", onChange: this.onChange, checked: true }),
                omi_1.h("div", { class: "o-switch-cp__box" })));
        }
        return (omi_1.h("input", __assign({}, omi_1.extractClass(props, 'o-switch'), { type: "checkbox", ref: function (e) {
                _this._ele = e;
            }, onChange: this.onChange })));
    };
    Switch.css = css;
    Switch.propTypes = {
        checked: Boolean
    };
    Switch = __decorate([
        omi_1.tag('o-switch')
    ], Switch);
    return Switch;
}(omi_1.WeElement));
exports.default = Switch;
